export default __webpack_public_path__ + "static/media/emojiHappy.0930eb28.png";